import React, { useState } from "react";
import TextInputWithIcon from "../Common/TextInputWithIcon";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { IonButton } from "@ionic/react";
import User from "services/User";
import Modal from "react-modal";
import { ClipLoader } from "react-spinners";
import CancelPopUp from "assets/images/icon/svg/CancelPopUp";
import { toast } from "react-toastify";
import ImagesUploader from "../Accounts/ImagesUploader";
import Blog from "services/Blog";
import { getUserBusiness } from "config/user";

export default function ArticleForm({ ekkLanguage }) {
	const [selectedDate, setSelectedDate] = useState(moment(new Date()));
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const navigate = useNavigate();
	const [imageFiles, setImageFiles] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const closeModal = () => setConfirmModal(false);
	const openModal = () => setConfirmModal(true);
	const [loader, setLoader] = useState(false);
	const [warningMessage, setWarningMessage] = useState("");
	const business = getUserBusiness();

	console.log(business?.business_name);

	const customStyles = {
		content: {
			top: "50%",
			left: "50%",
			right: "auto",
			bottom: "auto",
			marginRight: "-50%",
			transform: "translate(-50%, -50%)",
			padding: "0px",
			width: "300px",
			transition: ".4s all ease",
			borderRadius: 12,
		},
		overlay: {
			position: "fixed",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			transition: ".4s all ease",
			backgroundColor: "rgba(0,0,0,.5)",
		},
	};

	function DataURIToBlob(dataURI) {
		const splitDataURI = dataURI.split(",");
		const byteString =
			splitDataURI[0].indexOf("base64") >= 0
				? atob(splitDataURI[1])
				: decodeURI(splitDataURI[1]);
		const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

		const ia = new Uint8Array(byteString.length);
		for (let i = 0; i < byteString.length; i++)
			ia[i] = byteString.charCodeAt(i);

		return new Blob([ia], { type: mimeString });
	}

	let submitHandler = async () => {
		setLoader(true);

		try {
			// Process images if any
			const imageUrls = [];
			if (imageFiles?.length) {
				for (let index = 0; index < imageFiles.length; index++) {
					if (imageFiles[index]?.cameraImage) {
						const cameraFile = DataURIToBlob(imageFiles[index]?.preview);
						const cameraData = new FormData();
						cameraData.append("key", cameraFile, "image.jpg");
						let cameraResponse = await User.toBucketImage(cameraData);
						imageUrls.push(cameraResponse?.results[0]);
					} else {
						const imageData = new FormData();
						imageData.append(
							"key",
							imageFiles[index],
							`image-${index}.png`
						);
						try {
							const uploadResponse = await User.toBucketImage(imageData);
							imageUrls.push(uploadResponse?.results[0]);
						} catch (error) {
							console.error(`Error uploading image-${index}:`, error);
						}
					}
				}
			}

			// Create article payload
			let payload = {
				title: title,
				content: description,
				date: moment(selectedDate).format("YYYY-MM-DD"),
				images: imageUrls,
				thumbnail_image: imageUrls[0],
				language: "EN",
				apps: ["EkkBaz"],
				tags: [],
				type: "article",
				business_names: [business?.business_name],
				business_ids: [business?.id],
				context: "My Company",
			};

			// Replace with your article creation API call
			let response = await Blog.createArticle(payload);
			if (response.status === 201) {
				setLoader(false);
				closeModal();
				toast.success("Article created successfully");
				navigate("/learning");
				setTitle("");
				setDescription("");
				setImageFiles([]);
			} else {
				setLoader(false);
				toast.error("Failed to create article");
			}
		} catch (error) {
			console.error("Error creating article:", error);
			setLoader(false);
			toast.error("An error occurred while creating the article");
		}
	};

	return (
		<div className='pt-5'>
			<div>
				<div className='pb-5'>
					<div className='flex pb-4'>
						<h4 className='font-bold text-14'>Images *</h4>
					</div>
					<ImagesUploader
						files={imageFiles}
						setFiles={setImageFiles}
						bHeight={320}
					/>
				</div>
				<TextInputWithIcon
					type='text'
					title='Title'
					inputText={title}
					setInputText={setTitle}
					placeholder='Enter Title'
					required={true}
				/>
				<TextInputWithIcon
					type='textarea'
					title='Description'
					inputText={description}
					setInputText={setDescription}
					placeholder='Enter Description'
				/>
			</div>
			<div className='mb-8 mt-4'>
				<IonButton
					onClick={() => {
						if (!title) {
							setWarningMessage("Please enter a title");
							return false;
						} else if (imageFiles?.length === 0) {
							setWarningMessage("Please upload at least one image");
							return false;
						} else {
							openModal();
						}
					}}
					style={{ boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)" }}
					expand='block'
					className='bg-success rounded-[5px] h-12 font-sans font-bold text-20'>
					Submit Article
				</IonButton>
			</div>
			<Modal
				style={customStyles}
				closeTimeoutMS={200}
				isOpen={confirmModal}
				onRequestClose={closeModal}
				classNames='bottom-sheet-modal'>
				<div className='p-5'>
					<span className='mb-2 inline-block mx-2'>
						<CancelPopUp />
					</span>
					<h6 className='text-16 font-bold pb-[30px]'>
						Are you sure you want to create this article?
					</h6>

					<div className='flex justify-end'>
						<button
							className='border-2 font-bold h-10 rounded-[7px] w-1/2 mr-2 bg-primary text-white'
							onClick={closeModal}>
							No
						</button>
						<button
							color='primary'
							className={`${
								loader && "select-none cursor-no-drop"
							} font-bold h-10 rounded-[7px] w-1/2 ml-2 border-2 bg-success text-white flex justify-center items-center`}
							onClick={!loader ? submitHandler : undefined}>
							{loader ? (
								<ClipLoader
									sizeUnit={"px"}
									size={20}
									color={"white"}
									loading={true}
								/>
							) : (
								"Yes"
							)}
						</button>
					</div>
				</div>
			</Modal>
		</div>
	);
}
